<div class="form-group materialize {{behaviourClasses}}">
	<kendo-multiselect #multiselect class="form-control" [id]="controlId" [data]="data" [textField]="textField" [valueField]="valueField" [valueNormalizer]="valueNormalizer"
		[popupSettings]="popupSettings" [valuePrimitive]="valuePrimitive" [allowCustom]="allowCustom" [filterable]="filterable" [disabled]="disabled" [(ngModel)]="value"
		[ngModelOptions]="ngModelOptions" (focus)="_handleFocus($event)" (blur)="_handleBlur($event)" (valueChange)="_handleChange($event)"
		(selectionChange)="selectionChange.emit($event)" (filterChange)="_handleFilterChange($event)">
	</kendo-multiselect>
	<label [for]="controlId">{{label}}</label>
	<validation-messages *ngIf="showFailures" [messages]="failures"></validation-messages>
</div>